import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { useBreakpoints } from "react-device-breakpoints";
import Draggable from "react-draggable";
// import Footer from "../../components/Footer";
import { AiOutlineReload } from "react-icons/ai";
import { FaFilter } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import Header from "../../components/Header";
// import dataJson from "../../data.json";
// import { jobData } from "../../utils/mock_data";
import LeftSidebar from "./leftSidebar";
import Lists from "./lists";

const Home = () => {
  const [show, setShow] = useState(false);
  const [sidebarMinimize, setSidebarMinimize] = useState(false);
  // redux data
  const planList = useSelector((state) => state.listMyPlan.listMyPlan);
  // data
  const [data, setData] = useState(planList);
  // pagination
  const [page, setPage] = useState(0);
  const perPageShow = 6;
  const pageVisit = page * perPageShow;
  const pageCount = Math.ceil(data.length / perPageShow);
  const handlePageChange = ({ selected }) => {
    setPage(selected);
  };
  // on filter category
  const onCategoryFilter = (category) => {
    const job = planList.filter(
      (pd) => pd.category.toLowerCase() === category.toLowerCase()
    );
    setData(job);
    if (category === "Select") {
      setData(planList);
    }
  };
  // title filter
  const onTitleFilter = (title) => {
    if (title) {
      const job = planList.filter((pd) =>
        pd.title.toLowerCase().includes(title.toLowerCase())
      );
      setData(job);
    } else {
      setData(planList);
    }
  };
  // date filter
  const onDateFilter = (date) => {
    const mydate = new Date(date);
    const dateConv = mydate.toDateString().split(" ");
    const dateform = dateConv[2] + " " + dateConv[1] + ", " + dateConv[3];
    if (date) {
      const job = planList.filter((pd) => pd.postDate.includes(dateform));
      setData([...data, job]);
    } else {
      setData(planList);
    }
  };
  // rating filter
  const onRatingFilter = (rating) => {
    if (rating) {
      const job = planList.filter((pd) => pd.rating.includes(rating));
      setData(job);
    } else {
      setData(planList);
    }
  };
  // on price filter
  const onTagsFilter = (tag) => {
    if (tag) {
      const job = planList.filter((pd) => pd.tag.includes(tag));
      setData(job);
    } else {
      setData(planList);
    }
  };
  // device breakpoints
  const device = useBreakpoints();
  useEffect(() => {
    if (!device.isSemiPortraitTablet) {
      setShow(false);
    } else {
      setSidebarMinimize(false);
    }
  }, [device.isSemiPortraitTablet]);
  // multiselect dropdown functionality
  // select item
  const onSelect = (_, selectedItem) => {
    console.log(selectedItem);
  };
  //remvoe item
  const onRemove = (_, removedItem) => {
    console.log(removedItem);
  };
  return (
    <>
      <Header />
      <div className="content_wrapper">
        {/* <div className="container"> */}
        <div className="list_content_containers">
          <div
            className={`leftSidebar ${show ? "active" : ""}`}
            style={{ width: sidebarMinimize ? "60px" : "" }}
          >
            <LeftSidebar
              onTitleFilter={onTitleFilter}
              onDateFilter={onDateFilter}
              onRatingFilter={onRatingFilter}
              onTagsFilter={onTagsFilter}
              onCategoryFilter={onCategoryFilter}
              show={show}
              setShow={setShow}
              sidebarMinimize={sidebarMinimize}
              setSidebarMinimize={setSidebarMinimize}
            />
          </div>
          <div className="list_view">
            <div className="list_header">
              <div className="item_count">
                <h3>
                  <AiOutlineReload /> {planList.length} items
                </h3>
              </div>
              <div className="sorting">
                <div className="sorting_block">
                  <Multiselect
                    displayValue="key"
                    onRemove={onRemove}
                    onSelect={onSelect}
                    options={[
                      {
                        id: "7sd8fs8",
                        key: "All Items",
                      },
                      {
                        id: "7sf4se7s",
                        key: "Single Items",
                      },
                      {
                        id: "7fs7f7s",
                        key: "Bundle",
                      },
                    ]}
                    placeholder="Select"
                    showArrow={true}
                    singleSelect
                  />
                </div>
                <div className="sorting_block">
                  <Multiselect
                    displayValue="key"
                    onRemove={onRemove}
                    onSelect={onSelect}
                    options={[
                      {
                        id: "78s4fs",
                        key: "Sort: A-Z",
                      },
                      {
                        id: "7s8e8s8",
                        key: "Sort: Z-A",
                      },
                      {
                        id: "78s5f5se",
                        key: "Recently Created",
                      },
                      {
                        id: "47sjser",
                        key: "Rating: Low to High",
                      },
                      {
                        id: "8s57s7f",
                        key: "Rating: High to Low",
                      },
                    ]}
                    placeholder="Sort By"
                    showArrow={true}
                    singleSelect
                  />
                </div>
              </div>
            </div>
            <div className="lists">
              {data.length > 0 ? (
                data
                  .slice(pageVisit, pageVisit + perPageShow)
                  .map((item) => <Lists key={item._id} item={item} />)
              ) : (
                <div
                  className="empty"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "200px",
                  }}
                >
                  {" "}
                  <h3>No Plan Here...</h3>{" "}
                </div>
              )}
            </div>
            {data.length > 0 && (
              <ReactPaginate
                previousLabel={"prev"}
                nextLabel={"next"}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={"paginationButtons"}
                previousLinkClassName={"previousButtons"}
                nextLinkClassName={"nextButton"}
                disabledClassName={"disablePagination"}
                activeClassName={"paginationActive"}
              />
            )}
          </div>
        </div>
        {/* </div> */}
        {device.isSemiPortraitTablet && (
          <Draggable bounds="body">
            <div
              className="filter_btn"
              id="filter_btn"
              onTouchStart={() => setShow(true)}
              onClick={() => setShow(true)}
            >
              <h3>
                <FaFilter />
              </h3>
            </div>
          </Draggable>
        )}
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Home;
